// Initialize direct event handlers on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
    // Only add event handlers if ProductImageLoader is available
    if (window.productImageLoader) {
        // Add to cart button click handler
        $('.addToCart').on('click', function() {
            window.productImageLoader.stopAllCycles();
        });
        
        // Mobile add to bag trigger click handler
        $('.mobile-atb-trigger:not(.event-bound)').each(function() {
            $(this).addClass('event-bound');
            $(this).on('click', function() {
                const productCard = $(this).closest('.plp-product-standard .card-active')[0];
                if (productCard) {
                    window.productImageLoader.stopAllCycles();
                    window.productImageLoader.startCycle(productCard);
                }
            });
        });
    } else {
        console.warn('ProductImageLoader not found - image cycling disabled');
    }
});

// Event handlers for add to bag buttons
$(document).on('click', '.plp--atb-trigger:not(.js-product-add-to-cart-plp):not(.plp-final-sale-options-trigger):not(.item-in-cart)', function(){
    var $this = $(this);
    
    // If ProductImageLoader is available, use it
    if (window.productImageLoader) {
        const productCard = $this.closest('.card-wrapper').get(0);
        if (productCard) {
            window.productImageLoader.stopAllCycles();
            window.productImageLoader.startCycle(productCard);
        }
    }
    
    $this.parents('.plp--atb').find('.plp-atb--buttons').addClass('plp-atb--show-options');
    $this.parents('.plp-product-grid-item').addClass('plp-atb-showing');
    $this.parents('.card-wrapper').addClass('card-showing-atb');
    $this.parents('.card-wrapper').addClass('hovering-card');
    $this.parents('.collection-grid-product-item').addClass('plp-atb--active');
});

$(document).on('click', '.plp-final-sale-options-trigger:not(.item-in-cart)', function(){
    var $this = $(this);
    
    $this.parents('.plp--atb').find('.plp-atb--buttons').addClass('plp-atb--show-final-sale-options');
});

window.addEventListener('scroll', function(){
    $('.plp-atb').removeClass('show-atb-options');
    $('.plp-atb').removeClass('plp-atb-show');
}, true);

$(document).mouseup(function (e) {
    const container = $(".plp-atb");
    if(!container.is(e.target) && container.has(e.target).length === 0) {
        $('.plp-atb').removeClass('show-atb-options');
    }
});

$(document).on('click', 'button.btn.btn-solid.plp-trigger-inner-options', function(){
    var $this = $(this);
    $this.parents('.plp-atb--buttons').find('.plp-atb--buttons-inner').addClass('plp-atb--show--inner-options');
    $this.parents('.plp-atb--buttons').addClass('plp-atb--show--inner-options-final-sale');
    $('body').addClass('body-plp-atb--show--inner-options');
});

$(document).on('click', '.atb-options-trigger:not(.item-in-cart)', function(){
    var $this = $(this);
    $('.plp-atb').removeClass('show-atb-options');
    $this.parents('.plp-atb').addClass('show-atb-options');
});

$(document).on('click', '.mobile-atb-trigger', function(){
    var $this = $(this);
    $('.plp-atb').removeClass('plp-atb-show');
    $this.parents('.plp-atb').addClass('plp-atb-show');
});